<div class="onboarding-card-title" translate>ai-exam-onboarding.otp.title</div>
<div class="onboarding-card-subtitle">
    <span translate>ai-exam-onboarding.otp.description</span>
    @if (elate?.user?.personification?.email) {
    <strong>{{ elate.user.personification.email }}</strong>
    }
</div>

<div class="otp-group">
    @for (i of [0, 1, 2, 3, 4, 5]; track i) {
    <input #codeInput class="otp-input" type="text" inputmode="numeric" maxlength="1"
        [class.filled]="codeDigits[i]"
        (input)="onInput(i, $event)"
        (keydown)="onKeyDown(i, $event)"
        (focus)="onFocus(i, $event)"
        (paste)="onPaste($event)">
    }
</div>

@if (successMessage()) {
<div class="message message--success">{{ successMessage() }}</div>
}
@if (resendMessage()) {
<div class="message message--info">{{ resendMessage() }}</div>
}
@if (errorMessage()) {
<div class="message message--error">{{ errorMessage() }}</div>
}

<button type="button" class="onboarding-btn-primary onboarding-btn-primary--full"
    (click)="verifyCode()"
    [disabled]="loading() || codeDigits.join('').length !== 6 || codeVerified()">
    @if (!loading()) {
    <span translate>ai-exam-onboarding.otp.verify-button</span>
    } @else {
    <span class="inline-flex items-center justify-center gap-2">
        <mat-spinner [diameter]="18" [strokeWidth]="3"></mat-spinner>
        <span translate>ai-exam-onboarding.otp.verifying</span>
    </span>
    }
</button>

<div class="resend">
    <span translate>ai-exam-onboarding.otp.resend-prompt</span>
    <a href="#" (click)="resendCode(); $event.preventDefault()" translate>ai-exam-onboarding.otp.resend-button</a>
</div>

<div class="reassurance">
    <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.2"/>
        <path d="M7 4.5V7.5L8.5 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
    <div class="reassurance-text" translate>ai-exam-onboarding.otp.reassurance</div>
</div>
